import { useEffect, useRef } from 'react';
import { useLang } from '../context/LangContext';

function removeBackground(img) {
  if (!img) return;
  const source = new Image();
  source.onload = function () {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    canvas.width = source.naturalWidth;
    canvas.height = source.naturalHeight;
    ctx.drawImage(source, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const pts = [[0,0],[canvas.width-1,0],[0,canvas.height-1],[canvas.width-1,canvas.height-1],[Math.floor(canvas.width/2),0]];
    let r=0,g=0,b=0;
    pts.forEach(([x,y]) => { const i=(y*canvas.width+x)*4; r+=data[i];g+=data[i+1];b+=data[i+2]; });
    const bg = { r:Math.round(r/5), g:Math.round(g/5), b:Math.round(b/5) };
    const tol=54, fth=28;
    for (let i=0;i<data.length;i+=4) {
      const d=Math.sqrt(Math.pow(data[i]-bg.r,2)+Math.pow(data[i+1]-bg.g,2)+Math.pow(data[i+2]-bg.b,2));
      if (d<tol) data[i+3]=0;
      else if (d<tol+fth) data[i+3]=Math.min(data[i+3],Math.round(((d-tol)/fth)*255));
    }
    ctx.putImageData(imageData,0,0);
    img.src=canvas.toDataURL('image/png');
  };
  source.src = img.src;
}

function CtaCard({ href, icon, titleKey }) {
  const { t } = useLang();
  const imgRef = useRef();

  useEffect(() => {
    if (!icon) return;
    if (imgRef.current?.complete) removeBackground(imgRef.current);
    else imgRef.current?.addEventListener('load', () => removeBackground(imgRef.current));
  }, [icon]);

  return (
    <a href={href} className="cta-card" aria-label={t(titleKey)}>
      {icon && (
        <div className="cta-icon-wrap" aria-hidden="true">
          <img ref={imgRef} src={icon} alt="" />
        </div>
      )}
      <div className="cta-title">{t(titleKey)}</div>
    </a>
  );
}

export default function CtaGrid() {
  return (
    <div className="cta-grid">
      <CtaCard href="#"         icon="/assets/icons/icon-tienda.png"         titleKey="cta.store"    />
      <CtaCard href="#"         icon="/assets/icons/icon-centro-negocio.png" titleKey="cta.business" />
      <CtaCard href="/nosotros" icon="/assets/icons/icon-porque.png"          titleKey="cta.why"      />
    </div>
  );
}
